<template>
  <div id="vehicleSelector">
    <v-autocomplete
      hide-details="auto"
      v-model="selectedVehicleGroups"
      :label="labels.groups"
      color="orange"
      multiple
      dense
      outlined
      :items="vehicleGroups"
      item-text="name"
      item-value="id"
      @change="filterVehicleDropdown"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click="toggleGroups">
          <v-list-item-action>
            <v-icon
              :color="selectedVehicles.length > 0 ? 'indigo darken-4' : ''"
              >{{ groupIcon }}</v-icon
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ labels.selectAll }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>

    <v-autocomplete
      hide-details="auto"
      v-model="selectedVehicles"
      :label="labels.vehicles"
      :multiple="isMultiple"
      dense
      outlined
      color="orange darken-1"
      :items="vehiclesToShow"
      item-text="name"
      item-value="id"
      :error-messages="errorMsg"
    >
      <template v-slot:prepend-item v-if="isMultiple">
        <v-list-item ripple @click="toggle">
          <v-list-item-action>
            <v-icon
              :color="selectedVehicles.length > 0 ? 'indigo darken-4' : ''"
              >{{ icon }}</v-icon
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ labels.selectAll }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { get } from '@/api/vehicle.api'
import { getAllGroups } from '@/api/vehicleGroups.api'
import EventBus from '../event-bus'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'VehicleSelectorComponent',
  props: {
    isMultiple: {
      default: true,
      type: Boolean
    },
    vehiclesFilter: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      vehicleGroups: [],
      vehicles: [],
      selectedVehicleGroups: [],
      selectedVehicles: [],
      vehiclesToShow: [],
      labels: {
        selectAll: translate('Select All', 'fields'),
        groups: translate('Groups', 'vehicleSelector'),
        vehicles: translate('Vehicles', 'vehicleSelector')
      }
    }
  },
  mounted() {
    EventBus.$on('PRESELECT_VEHICLES', this.preSelectVehicleDropdown)

    get(this.vehiclesFilter)
      .then(response => {
        this.vehicles = response.data
        this.vehiclesToShow = response.data
      })
      .catch(error => {
        throw new Error(error)
      })

    getAllGroups()
      .then(response => {
        this.vehicleGroups = response.data
      })
      .catch(error => {
        throw new Error(error)
      })
  },
  watch: {
    selectedVehicles: {
      handler() {
        this.$emit('reportSearchDataObjectChanged', {
          key: 'vehicleIds',
          value: this.selectedVehicles
        })
      }
    }
  },
  computed: {
    selectedAll() {
      return this.selectedVehicles.length === this.vehicles.length
    },
    someSelected() {
      return this.selectedVehicles.length > 0 && !this.selectedAll
    },
    icon() {
      if (this.selectedAll) return 'mdi-close-box'
      if (this.someSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    groupsSelectedAll() {
      return this.selectedVehicleGroups.length === this.vehicleGroups.length
    },
    someGroupsSelected() {
      return this.selectedVehicleGroups.length > 0 && !this.groupsSelectedAll
    },
    groupIcon() {
      if (this.groupsSelectedAll) return 'mdi-close-box'
      if (this.someGroupsSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    errorMsg() {
      if (this.$attrs.errorMessages && this.$attrs.errorMessages.length) {
        return this.$attrs.errorMessages[0]
      }
      return null
    }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.selectedVehicles = []
        } else {
          this.selectedVehicles = this.vehicles.map(x => x.id)
        }
      })
    },
    toggleGroups() {
      this.$nextTick(() => {
        if (this.groupsSelectedAll) {
          this.selectedVehicleGroups = []
        } else {
          this.selectedVehicleGroups = this.vehicleGroups.map(x => x.id)
        }

        this.filterVehicleDropdown()
      })
    },
    filterVehicleDropdown() {
      this.vehiclesToShow = []

      if (this.selectedVehicleGroups.length === 0) {
        this.vehiclesToShow = this.vehicles
      } else {
        this.vehicles.forEach(vehicle => {
          this.selectedVehicleGroups.forEach(group => {
            if (vehicle.vehicleGroupIds.includes(group)) {
              this.vehiclesToShow.push(vehicle)
            }
          })
        })
      }
    },
    preSelectVehicleDropdown(data) {
      this.selectedVehicles = data
    }
  }
}
</script>
